import { CreateServiceAreaButton } from "@/features/service-areas/create-service-area-button";
import { ServiceAreasTable } from "@/features/service-areas/service-areas-table";

export function ServiceAreasListScreen() {
  return (
    <div className="p-4">
      <div className="mb-6 flex flex-wrap items-center justify-between gap-4">
        <div>
          <h1 className="text-3xl font-bold">Service Areas</h1>
          <p className="text-gray-600 mt-2">Manage delivery service areas</p>
        </div>
        <CreateServiceAreaButton />
      </div>
      <ServiceAreasTable />
    </div>
  );
}
